import { useMemo } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { usePollingResource } from '../../security/hooks/usePollingResource';
import { workItemsApi } from '../services/workItemsApi';
import type { WorkItemFilters, WorkItemListResponse } from '../types/workItems';

const DEFAULT_INTERVAL_MS = 30_000;

/**
 * Polling list of work items (WQ-298). Reuses the Security Dashboard's generic
 * `usePollingResource` (30s poll, pause-on-blur). Filters serialize to a stable
 * key so the effect restarts only when filters actually change.
 */
export function useWorkItems(
  filters: WorkItemFilters = {},
  intervalMs: number = DEFAULT_INTERVAL_MS,
) {
  const { authFetch } = useAuth();
  const filterKey = useMemo(() => JSON.stringify(filters), [filters]);

  return usePollingResource<WorkItemListResponse>({
    fetcher: () => workItemsApi.list(authFetch, filters),
    intervalMs,
    deps: [filterKey],
  });
}
